import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 9px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 50%;
`;

export const FormatWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: center;
  line-height: 1;
`;

export const NumberText = styled.span`
  color: ${({ theme }) => theme.colors.black9};
  text-align: right;
  font-size: 38px;
  font-weight: 600;
`;

export const PercentSymbol = styled.span`
  color: ${({ theme }) => theme.colors.black9};
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
`;
